import { render, staticRenderFns } from "./AdditionalProductEditor.vue?vue&type=template&id=4a7e5837&scoped=true"
import script from "./AdditionalProductEditor.vue?vue&type=script&lang=js"
export * from "./AdditionalProductEditor.vue?vue&type=script&lang=js"
import style0 from "./AdditionalProductEditor.vue?vue&type=style&index=0&id=4a7e5837&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4a7e5837",
  null
  
)

export default component.exports